import OptionStep from "./OptionStep"

const options = [
    { label: "Pakistan", value: "pk" },
    { label: "Bangladesh", value: "bg" },
    { label: "Nepal", value: "np" },
    { label: "Sri Lanka", value: "sl" },
    { label: "Malysia", value: "my" },
    { label: "Indonesia", value: "id" },
    { label: "Singapur", value: "sg" },
    { label: "Thailand", value: "th" },
    { label: "The Philippines", value: "ph" },
    { label: "Vietnam", value: "vn" },
]

const Marketplace = () => (
    <OptionStep
        heading="Choose your marketplace"
        description="Help us to show you data as per your marketplace."
        options={options}
        field="marketplace"
        nextStep="referrer"
    />
)

export default Marketplace
